import styled from 'styled-components';
import theme from 'common/theme'
import { LabelWithCircleContainer  } from './LabelWithCircle.elements';

export const LegendItemContainer = styled(LabelWithCircleContainer)<{color?: string, colorr?: string}>`
   padding-right: 1em;
`

export const ChartLegendContainer = styled.div<{gridCols?: string, [key: string]: unknown}>`
  display: grid;
  grid-template-columns: 1fr auto;
  height: max-content;
  font-size: .8em;
  
  &[data-init="false"] {
    overflow: hidden;
    .dropdown-btn {
      visibility: hidden;
    }
  }

  .inline-legend-items {
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: max-content;
    overflow: hidden;
    width: 100%;
     //min-height: 1em;
 
    flex-wrap: no-wrap;
    overflow: hidden;
    position: relative;
  }

   

  &.wrapped {
    .inline-legend-items {
      display: block;
      overflow: auto;
    }
  }

  .is-hidden {
    grid-row: 2;
  }

  &.has-dropdown {
    overflow: visible;

    .dropdown-btn {
      display: flex;
    }
  }

  .dropdown-btn { 
    position: relative;
    display: none;
    flex-grow: 0;
    
    .ico {
      align-items: center;
      justify-content: center;
      display: flex;
    }
  }

  .dropdown-area { 
    position: absolute;
    right: 0;
    top: 100%;
    display: none;
    padding: 1em .25em 1em .5em;
    background-color: white;
    box-shadow: ${theme.effects.boxShadow.tooltip};
    border-radius: 5px;
    flex-direction: column;
    gap: .5em;
    overflow: hidden;

    .scroll-mask {
      max-height: 200px;
      overflow: auto;
      
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: .5em;
    }
  }

  &:hover {
    z-index: 100;
    .dropdown-area {
      display: flex;
      
    }
  }

 
`;
 